import { useAuth } from "@qure/qure-auth";
function useAdminPriveleges() {
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var hasPrivileges = Array.isArray(userInfo === null || userInfo === void 0 ? void 0 : userInfo.approve_site_sources) && userInfo.approve_site_sources.length !== 0;
  return hasPrivileges;
}
export default useAdminPriveleges;